import React from 'react';
import { Link } from 'react-router-dom';
import '../CSS/SiteMap.css';

const SiteMap: React.FC = () => {
  return (
    <div className="sitemap-page">
      <div className="sitemap-hero">
        <div className="sitemap-hero-content">
          <p className="sitemap-breadcrumb">Home / <b>Sitemap</b></p>
          <h1 className="sitemap-title">Sitemap</h1>
        </div>
      </div>

      <div className="sitemap-body">
        <div className="sitemap-container">
          <div className="sitemap-nav-column">
            <h3 className="sitemap-nav-title">About Us</h3>
            <ul className="sitemap-nav-list">
              <li><Link to="/our-history">Our History</Link></li>
              <li><Link to="/teams">Our Team</Link></li>
            </ul>
          </div>

          <div className="sitemap-nav-column">
            <h3 className="sitemap-nav-title">Who We Serve</h3>
            <ul className="sitemap-nav-list">
              <li><Link to="/higher-education">Higher Education</Link></li>
              <li><Link to="/healthcare">Healthcare</Link></li>
            </ul>
          </div>

          <div className="sitemap-nav-column">
            <h3 className="sitemap-nav-title"><Link to="/current-searches">Current Searches</Link></h3>
          </div>

          <div className="sitemap-nav-column">
            <h3 className="sitemap-nav-title">Our Services</h3>
            <ul className="sitemap-nav-list">
              <li><Link to="/services/executive-search">Executive Search and Placement Services</Link></li>
              <li><Link to="/services/ai-innovation">AI Innovation & Academic Modernization</Link></li>
              <li><Link to="/services/campus-safety">Campus Safety Audits: From Risk to Resilience</Link></li>
              <li><Link to="/services/executive-coaching">Executive Coaching for Academic Leaders</Link></li>
            </ul>
          </div>

          <div className="sitemap-nav-column">
            <h3 className="sitemap-nav-title">News & Insights</h3>
            <ul className="sitemap-nav-list">
              <li><Link to="/news-and-insights/recent-placements">Recent Placements</Link></li>
              <li><Link to="/news-and-insights/monthly-newsletter">E-Newsletters</Link></li>
              <li><Link to="/news-and-insights/our-success-stories">Our Success Stories</Link></li>
            </ul>
          </div>

          <div className="sitemap-nav-column">
            <h3 className="sitemap-nav-title"><Link to="/contact-us">Contact Us</Link></h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SiteMap;

